angular.module('ControllersModule')
  .controller('HelpCenterController', function ($scope, $rootScope, $timeout) {

  $scope.loadingPage = true;

  ChurnZero.push(['ChurnZeroEvent:on', 'connected', function (data) {
    $timeout(function() {
      $scope.loadingPage = false;
      $scope.$apply();
    })
  }]);
  
  $scope.openSuccessCenter = function() {
    ChurnZero.push(['open']);
  }

  $scope.openSupportTicket = function() {
    window.frames['JSD widget'].document.getElementById('help-button').click();
  }
});
